"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExempleItem = exports.processExample = exports.uploadExcelImpl = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const d3 = __importStar(require("d3"));
const d3_textwrap_1 = require("d3-textwrap");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const SankeyConvert_1 = require("./SankeyConvert");
const SankeyLayout_1 = require("./SankeyLayout");
const file_saver_1 = __importDefault(require("file-saver"));
const SankeyUtils_1 = require("./SankeyUtils");
const Accordion_1 = __importDefault(require("react-bootstrap/Accordion"));
const fa_1 = require("react-icons/fa");
const react_multi_select_component_1 = require("react-multi-select-component");
const SankeyEdition_1 = __importDefault(require("./SankeyEdition"));
const SankeyDraw_1 = __importDefault(require("./SankeyDraw"));
const SankeyTooltip_1 = require("./SankeyTooltip");
const SankeyNodeEdition_1 = __importDefault(require("./SankeyNodeEdition"));
const SankeyLinkEdition_1 = __importDefault(require("./SankeyLinkEdition"));
const uploadExcelImpl = (data, set_data, set_show_excel_dialog, input_file, sheet, post_callback) => {
    const form_data = new FormData();
    form_data.append('file', input_file);
    // form_data.append(
    //   'sheet', sheet
    // )
    const path = window.location.href;
    const url = path + 'sankey/upload_excel';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const callback = (server_data) => {
        const error = server_data['error'];
        if (error && error.length != 0) {
            alert(error);
            return;
        }
        Object.assign(data, server_data);
        (0, SankeyConvert_1.convert_data)(data);
        //compute_auto_sankey(data, 200)
        let nb_agregation_level = 0;
        Object.values(data.nodes).forEach(n => Object.entries(n.dimensions).forEach(dim => nb_agregation_level = dim[1].level > nb_agregation_level ? dim[1].level : nb_agregation_level));
        (0, SankeyUtils_1.set_nodes_level)(data, data.nodes, nb_agregation_level);
        (0, SankeyLayout_1.compute_auto_sankey)(data, data.h_space ? data.h_space : 200);
        for (let i = nb_agregation_level; i > 0; i--) {
            (0, SankeyUtils_1.set_nodes_level)(data, data.nodes, i, false);
        }
        post_callback(data);
        set_data(Object.assign({}, data));
    };
    fetch(url, fetchData).then(response => {
        response.text().then(text => {
            // try {
            const json_data = JSON.parse(text);
            callback(json_data);
            const test = document.getElementsByClassName('navbar');
            let margin_top = 0;
            if (test && test.length > 0) {
                margin_top = test[0].getBoundingClientRect().height;
                d3.select('#svg-container').style('margin-top', margin_top + 'px');
            }
            // } catch(err) {
            //   alert(err)
            // }
        });
    });
    set_show_excel_dialog(false);
};
exports.uploadExcelImpl = uploadExcelImpl;
const MenuPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    open_menu: prop_types_1.default.element,
    save_menu: prop_types_1.default.element,
    edition_menu: prop_types_1.default.element,
    right_menu: prop_types_1.default.element,
    settings_edition: prop_types_1.default.element,
    settings_edition_node_tags: prop_types_1.default.element,
    settings_edition_link_tags: prop_types_1.default.element,
    settings_edition_data_tags: prop_types_1.default.element,
    node_edition: prop_types_1.default.element,
    link_edition: prop_types_1.default.element,
    logo: prop_types_1.default.string.isRequired,
    logo_width: prop_types_1.default.number.isRequired,
    app_name: prop_types_1.default.string.isRequired,
    set_show_toast: prop_types_1.default.func.isRequired,
    show_toast: prop_types_1.default.bool.isRequired,
    button_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLLabelElement) }),
    accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }),
    nodes_accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }),
    links_accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }),
    multi_selected_nodes: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    multi_selected_label: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLabelPropTypes).isRequired).isRequired }).isRequired,
    selected_link: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired }).isRequired,
    selected_node: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired }).isRequired,
    example_menu: prop_types_1.default.element,
    // portfolio_menu: PropTypes.element,
    formations_menu: prop_types_1.default.element,
    url_prefix: prop_types_1.default.string.isRequired,
    view: prop_types_1.default.string.isRequired,
    set_view: prop_types_1.default.func.isRequired,
    additional_selector: prop_types_1.default.element,
    set_current_filter: prop_types_1.default.func.isRequired,
    mode_selection: prop_types_1.default.string.isRequired,
    set_mode_selection: prop_types_1.default.func.isRequired,
    style_to_apply: prop_types_1.default.string.isRequired,
    set_style_to_apply: prop_types_1.default.func.isRequired,
    mode_visualisation: prop_types_1.default.bool.isRequired,
    set_mode_visualisation: prop_types_1.default.func.isRequired
};
const processExample = (server_data) => {
    // if (path.includes('v1/filiere_foret_bois_savoie_reconciled.xlsx')) {
    //   server_data.links['link324'].idSource = 'node63'
    //   delete server_data.links['link325']
    // }
    let nb_agregation_level = 0;
    Object.values(server_data.nodes).forEach(n => Object.entries(n.dimensions).forEach(dim => nb_agregation_level = dim[1].level > nb_agregation_level ? dim[1].level : nb_agregation_level));
    (0, SankeyUtils_1.set_nodes_level)(server_data, server_data.nodes, nb_agregation_level);
    (0, SankeyLayout_1.compute_auto_sankey)(server_data, server_data.h_space ? server_data.h_space : 200);
    for (let i = nb_agregation_level; i > 0; i--) {
        (0, SankeyUtils_1.set_nodes_level)(server_data, server_data.nodes, i, false);
    }
    if (server_data.layout !== undefined) {
        (0, SankeyConvert_1.convert_data)(server_data.layout);
        // let nb_agregation_level = 0
        // Object.values(server_data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
        for (let i = 1; i <= nb_agregation_level; i++) {
            (0, SankeyUtils_1.set_nodes_level)(server_data.layout, server_data.layout.nodes, i, false);
        }
        (0, SankeyLayout_1.updateLayout)(server_data, server_data.layout);
        // if (server_data.agregation.level === -1) {
        //   localStorage.setItem('initial_data',LZString.compress(JSON.stringify(server_data)))
        // } else {
        (0, SankeyUtils_1.set_nodes_level)(server_data, server_data.nodes, server_data.agregation.level, true);
        //}
        // for (let i=1 ; i<=nb_agregation_level ; i++) {
        //   set_nodes_level(server_data,server_data.nodes,i)
        //   updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
        // }
        // delete (server_data as SankeyData & { layout?: SankeyData }).layout
        // Object.assign(server_data,JSON.parse(localStorage.getItem('initial_data') as string))           
        // } else {
        //   set_nodes_level(server_data,server_data.nodes,2)
        //   compute_auto_sankey(server_data, server_data.h_space ? server_data.h_space : 200)
        //   set_nodes_level(server_data,server_data.nodes,1)
        //   compute_auto_sankey(server_data, server_data.h_space ? server_data.h_space : 200)
        //   return 0             
        // }
    }
    return 0;
};
exports.processExample = processExample;
const ExempleMenuDictTypes = prop_types_1.default.objectOf(prop_types_1.default.element.isRequired).isRequired;
const ExempleItemPropTypes = {
    exemple_menu: prop_types_1.default.oneOf([prop_types_1.default.element.isRequired, ExempleMenuDictTypes]).isRequired,
    url_prefix: prop_types_1.default.string.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    current_path: prop_types_1.default.string.isRequired,
    multi_selected_nodes: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    multi_selected_label: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLabelPropTypes).isRequired).isRequired }).isRequired,
    callback: prop_types_1.default.func.isRequired
};
const ExempleItem = ({ exemple_menu, url_prefix, data, set_data, current_path, multi_selected_nodes, multi_selected_links, multi_selected_label, callback }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, Array.isArray(exemple_menu)
        ? exemple_menu.map((item, index) => {
            let the_callback = () => 0;
            let path = current_path + '/sankey/' + item;
            if (!item.includes('.xlsx') && !item.includes('.json')) {
                let url = window.location.origin + '/fm/userfiles/' + current_path + '/' + item;
                let suffix = 'ZIP';
                if (!item.includes('zip')) {
                    url = url + '/index.html';
                    suffix = 'HTML';
                }
                return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, href: url, target: "_blank" }, current_path.split('/').slice(0, -1).pop() + ' ' + suffix));
            }
            if (item.includes('.xlsx')) {
                the_callback = callback;
                path = current_path + '/' + item;
            }
            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, onClick: () => {
                    multi_selected_nodes.current = [];
                    multi_selected_links.current = [];
                    multi_selected_label.current = [];
                    (0, SankeyUtils_1.uploadExemple)(path, url_prefix, data, set_data, the_callback);
                } }, item.includes('xlsx') ? item.includes('reconciled') ? item.split('.x')[0].replace(/_/g, ' ').replace('reconciled', ' sortie') : item.split('.x')[0].replace(/_/g, ' ') + ' entrée'
                : item.includes('json') ? item.replace(/_/g, ' ').replace(' layout.json', '') : item.replace('afmsankey_0.9.0.', '')));
        }) : Object.keys(exemple_menu).map((key, index) => {
        let title = key;
        if (title === 'artefacts') {
            title = 'Page Web et Zip';
        }
        let the_current_path = current_path;
        if (!key.includes('OpenSankey')) {
            the_current_path = current_path !== '' ? current_path + '/' + key.replace('Sankey', '').replace('Excel', '') : key.replace('Sankey', '').replace('Excel', '');
        }
        else {
            the_current_path = current_path + '/' + key;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'start', key: index, title: title, id: key },
                react_1.default.createElement(exports.ExempleItem, { exemple_menu: exemple_menu[key], url_prefix: url_prefix, data: data, set_data: set_data, current_path: the_current_path, multi_selected_links: multi_selected_links, multi_selected_nodes: multi_selected_nodes, multi_selected_label: multi_selected_label, callback: callback }))));
    })));
};
exports.ExempleItem = ExempleItem;
const Menu = ({ data, set_data, open_menu, save_menu, edition_menu, right_menu, settings_edition, settings_edition_node_tags, settings_edition_link_tags, settings_edition_data_tags, node_edition, link_edition, logo, logo_width, app_name, button_ref, accordion_ref, nodes_accordion_ref, links_accordion_ref, selected_node, multi_selected_nodes, multi_selected_links, selected_link, example_menu, formations_menu, url_prefix, show_toast, set_show_toast, view, set_view, multi_selected_label, // set_multi_selected_label,
set_current_filter, additional_selector, mode_selection, set_mode_selection, style_to_apply, set_style_to_apply, mode_visualisation, set_mode_visualisation }) => {
    const set_show_link = (0, react_1.useState)(true)[1];
    const [show_excel_dialog, set_show_excel_dialog] = (0, react_1.useState)(false);
    const [legend_position, set_legend_position] = (0, react_1.useState)(data.legend_position);
    const [show_apply_layout, set_show_apply_layout] = (0, react_1.useState)(false);
    const { filter } = data.display_style;
    const [show_nav, set_show_nav] = (0, react_1.useState)(false);
    const [nav_item_active, set_nav_item_active] = (0, react_1.useState)('');
    const [sub_nav_item_active, set_sub_nav_item_active] = (0, react_1.useState)('');
    const [radio_selected] = (0, react_1.useState)('local');
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = (0, SankeyUtils_1.findMaxLinkValue)(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    let nb_agregation_level = 1;
    Object.values(data.nodes).forEach(n => {
        if (!n.dimensions) {
            return;
        }
        Object.entries(n.dimensions).forEach(dim => {
            if (!dim[1].level) {
                return;
            }
            nb_agregation_level = dim[1].level > nb_agregation_level ? dim[1].level : nb_agregation_level;
        });
    });
    //Ajoute un nouveau noeud puis le selectionne
    const add_new_node = () => {
        const { nodes } = data;
        const node = (0, SankeyUtils_1.default_node)(data);
        // Méthode pour incrementer idNode
        const listId = [];
        Object.keys(data.nodes).forEach(elt => listId.push(Number(elt.replace('node', ''))));
        const idNode = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        node.idNode = 'node' + idNode;
        node.name = node.idNode;
        if (Object.keys(nodes).length < 5) {
            node.x = Object.keys(nodes).length * 200 + 200;
        }
        else {
            node.x = 200;
        }
        nodes[node.idNode] = node;
        for (const tag_group_key in data.nodeTags) {
            node.tags[tag_group_key] = [];
        }
        //WARNING : le set_multi_select ne semble pas changer les noeuds sélectionnés avant d'appliquer le style 
        //set_multi_selected_nodes([node])
        multi_selected_nodes.current = [node];
        style_to_apply = 'default';
        apply_style_to_nodes();
        set_data(Object.assign({}, data));
    };
    const _load_json = (0, react_1.useRef)(null);
    const [processing] = (0, react_1.useState)(false);
    const clickSaveDiagram = () => {
        const data_to_save = Object.assign({}, data);
        const str_data = JSON.stringify(data_to_save, null, 2);
        const blob = new Blob([str_data], { type: 'text/plain;charset=utf-8' });
        file_saver_1.default.saveAs(blob, 'sankey_diagram.json');
    };
    const clickSaveExcel = () => {
        let root = window.location.href;
        if (root.includes('sankey-diagrams') && url_prefix !== '') {
            root = root.replace('sankey-diagrams/', '');
        }
        let url = root + url_prefix + 'sankey/save_excel';
        const fetchData = {
            method: 'POST',
            body: JSON.stringify(data)
        };
        const showFile = (blob) => {
            const newBlob = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            file_saver_1.default.saveAs(newBlob, 'sankey.xlsx');
        };
        const cleanFile = () => {
            const fetchData = {
                method: 'POST'
            };
            url = root + url_prefix + 'sankey/clean_excel';
            fetch(url, fetchData);
        };
        fetch(url, fetchData).then(r => r.blob())
            .then(showFile).then(cleanFile);
    };
    const clickSaveSVG = () => {
        const svg = window.d3.select('#svg-container svg');
        svg.selectAll('.sankey-tooltip').remove();
        svg.selectAll('text[visibility=hidden]').remove();
        const html = svg.attr('title', 'test2')
            .attr('version', 1.1)
            .attr('xmlns', 'http://www.w3.org/2000/svg')
            .node().parentNode.innerHTML;
        const blob = new Blob([html], { type: 'image/svg+xml' });
        file_saver_1.default.saveAs(blob, 'sankey_diagram.svg');
    };
    const clickSavePDF = () => {
        const svg = window.d3.select('#svg-container svg');
        svg.selectAll('.sankey-tooltip').remove();
        svg.selectAll('text[visibility=hidden]').remove();
        svg.attr('viewBox', [0, 0, data.width, data.height]);
        const html = svg.attr('title', 'test2')
            .attr('version', 1.1)
            .attr('xmlns', 'http://www.w3.org/2000/svg')
            .node().parentNode.innerHTML;
        const blob = new Blob([html], { type: 'image/svg+xml' });
        const form_data = new FormData();
        form_data.append('svg', blob);
        const path = window.location.href;
        let url = path + 'sankey/save_pdf';
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        const showFile = (blob) => {
            const newBlob = new Blob([blob], { type: 'application/pdf' });
            file_saver_1.default.saveAs(newBlob, 'sankey_diagram.pdf');
        };
        const cleanFile = () => {
            const fetchData = {
                method: 'POST'
            };
            url = path + 'sankey/clean_pdf';
            fetch(url, fetchData);
        };
        fetch(url, fetchData).then(r => r.blob())
            .then(showFile).then(cleanFile);
    };
    //Réinitialise data et vide les noeud/liens sélectionnés 
    const reinitialization = () => {
        const data = (0, SankeyUtils_1.default_sankey_data)();
        multi_selected_nodes.current = [];
        multi_selected_links.current = [];
        multi_selected_label.current = [];
        localStorage.removeItem('diff');
        localStorage.removeItem('data');
        localStorage.removeItem('initial_data');
        set_selected_style_node('default');
        set_selected_style_link('default');
        set_view('none');
        set_data(Object.assign({}, data));
    };
    //Modifie la variable qui permet d'afficher le menu accordéon
    const toggleShow = () => {
        set_show_nav(!show_nav);
        if (button_ref && button_ref.current) {
            button_ref.current.click();
        }
    };
    const setChecked = (0, react_1.useState)(false)[1];
    //Ajoute un nouveau flux et le sélectionne
    const add_new_link = () => {
        const { nodes, links } = data;
        if (Object.keys(nodes).length < 2) {
            return;
        }
        const link = (0, SankeyUtils_1.default_link)(data);
        // Méthode pour incrementer idNode
        const listId = [];
        Object.keys(data.links).forEach(elt => listId.push(Number(elt.replace('link', ''))));
        const idLink = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        link.idLink = 'link' + idLink;
        links[link.idLink] = link;
        const node_keys = Object.keys(nodes);
        link.idSource = nodes[node_keys[0]].idNode;
        link.idTarget = nodes[node_keys[1]].idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        nodes[node_keys[0]].outputLinksId.push(link.idLink);
        nodes[node_keys[1]].inputLinksId.push(link.idLink);
        selected_link.current = link;
        multi_selected_links.current = [link];
        set_data(Object.assign({}, data));
        set_show_link(true);
    };
    let node = data.nodes[selected_node.current.idNode];
    if (node === undefined) {
        node = (0, SankeyUtils_1.default_node)(data);
    }
    //Change la source du flux sélectionné
    const source_change = (changeEvent) => {
        const link = multi_selected_links.current[0];
        //Causait un problème d'acumulation de la valeur de des differents link sur des noeuds non associé
        const previous_node = data.nodes[link.idSource];
        previous_node.outputLinksId.splice(previous_node.outputLinksId.indexOf(multi_selected_links.current[0].idLink), 1);
        const source_node = data.nodes[changeEvent.target.value];
        link.idSource = source_node.idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        source_node.outputLinksId.push(multi_selected_links.current[0].idLink);
        set_data(Object.assign({}, data));
    };
    const addDropSource = () => {
        if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0 && multi_selected_links.current.length != 0) {
            return (Object.values(data.nodes).map((n, i) => react_1.default.createElement("option", { key: i, value: n.idNode, selected: multi_selected_links.current[0].idSource === n.idNode }, n.name)));
        }
    };
    const addDropCible = () => {
        if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0 && multi_selected_links.current.length != 0) {
            return (Object.values(data.nodes).map((n, i) => react_1.default.createElement("option", { key: i, value: n.idNode, selected: multi_selected_links.current[0].idTarget === n.idNode }, n.name)));
        }
    };
    //Change la cible du flux sélectionné
    const target_change = (changeEvent) => {
        const { nodes } = data;
        const link = multi_selected_links.current[0];
        const previous_node = nodes[link.idTarget];
        previous_node.inputLinksId.splice(previous_node.inputLinksId.indexOf(multi_selected_links.current[0].idLink), 1);
        const target_node = nodes[changeEvent.target.value];
        link.idTarget = target_node.idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        target_node.inputLinksId.push(multi_selected_links.current[0].idLink);
        set_data(Object.assign({}, data));
    };
    const tmpNodes = Object.fromEntries(Object.entries(data.nodes).sort(([, a], [, b]) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
    const INITIAL_OPTIONS = Object.values(tmpNodes).map((d) => { return { 'label': d.name, 'value': d.idNode }; });
    // const INITIAL_OPTIONS = Object.values(data.nodes).map(d => d.name).sort().map((d) => { return { 'label': d, 'value': d } })
    const selected = multi_selected_nodes.current.map((d) => { return { 'label': d.name, 'value': d.idNode }; });
    const props = {
        scroll: true,
        backdrop: false,
    };
    //Renvoie le menue déroulant pour la sélection des noeuds
    const dropdownMultiNode = () => {
        console.log(multi_selected_nodes.current);
        const DD = (react_1.default.createElement("div", { id: 'DD_multi_node' },
            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { valueRenderer: (selected) => {
                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun noeud sélectionné';
                }, options: INITIAL_OPTIONS, value: selected, overrideStrings: {
                    'selectAll': 'Tout sélectionner',
                }, onChange: (selected) => {
                    const new_sel = selected.map(d => d.value);
                    const m_s = Object.values(data.nodes).filter(d => (new_sel.includes(d.idNode)));
                    multi_selected_nodes.current = m_s;
                    Object.values(data.nodes).forEach(n => d3.select('#' + n.idNode).attr('stroke-width', 0));
                    multi_selected_nodes.current.forEach(n => d3.select('#' + n.idNode).attr('stroke-width', 2));
                    setForceUpdate(!forceUpdate);
                }, labelledBy: 'hello' })));
        return DD;
    };
    const tmplabel = Object.fromEntries(Object.entries(data.labels).sort(([, a], [, b]) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
    const INITIAL_OPTIONS_label = Object.values(tmplabel).map((d) => { return { 'label': d.name, 'value': d.idLabel }; });
    const selected_label = multi_selected_label.current.map((d) => { return { 'label': d.name, 'value': d.idLabel }; });
    //Renvoie le menue déroulant pour la sélection des labels libres
    const dropdownMultiLabel = () => {
        const DD = (react_1.default.createElement("div", { id: 'DD_multi_label' },
            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { valueRenderer: (selected) => {
                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun label sélectionné';
                }, options: INITIAL_OPTIONS_label, value: selected_label, overrideStrings: {
                    'selectAll': 'Tout sélectionner',
                }, onChange: (selected) => {
                    const new_sel = selected.map(d => d.value);
                    const m_s = Object.values(data.labels).filter(d => (new_sel.includes(d.idLabel)));
                    multi_selected_label.current = m_s;
                    setForceUpdate(!forceUpdate);
                }, labelledBy: 'hello' })));
        return DD;
    };
    const INITIAL_OPTIONS_LINKS = Object.values(data.links).map((d) => { return { 'label': (data.nodes[d.idSource].name + '--->' + data.nodes[d.idTarget].name), 'value': d.idLink }; });
    const selected_links = multi_selected_links.current.map((d) => {
        if (data.nodes[d.idSource] == undefined || data.nodes[d.idTarget] == undefined) {
            return;
        }
        return { 'label': (data.nodes[d.idSource].name + '--->' + data.nodes[d.idTarget].name), 'value': d.idLink };
    });
    //Renvoie le menue déroulant pour la sélection des flux
    const dropdownMultiLinks = () => {
        const DD = (react_1.default.createElement("div", { id: 'DD_multi_links' },
            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { valueRenderer: (selected) => {
                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun flux sélectionné';
                }, options: INITIAL_OPTIONS_LINKS, value: selected_links, overrideStrings: {
                    'selectAll': 'Tout sélectionner',
                }, onChange: (selected) => {
                    const new_sel = selected.map(d => d.value);
                    const m_s = Object.values(data.links).filter(d => (new_sel.includes(d.idLink)));
                    multi_selected_links.current = m_s;
                    Object.values(data.links).forEach(l => d3.selectAll('#gg_' + l.idLink + ' rect').attr('fill-opacity', '0'));
                    multi_selected_links.current.forEach(l => {
                        const sel = d3.selectAll('#gg_' + l.idLink + ' rect');
                        sel.attr('fill-opacity', '1');
                    });
                    setForceUpdate(!forceUpdate);
                }, labelledBy: 'hello' })));
        return DD;
    };
    const menuButton = () => {
        if (show_nav) {
            return 'Configuration Sankey';
        }
        else {
            return react_1.default.createElement(fa_1.FaAngleDoubleLeft, null);
        }
    };
    //Dépalce la place des liens sélectionnés vers le début dans le tableau de liens de data
    //Permet donc de les déssiner avant 
    const handleUpLink = (i) => {
        const { links } = data;
        const listElmt = Object.keys(links);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt - 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = links[elt];
        });
        for (const member in links)
            delete links[member];
        Object.assign(links, new_cat);
        set_data(Object.assign({}, data));
    };
    //Dépalce la place des liens sélectionnés vers la fin dans le tableau de liens de data
    //Permet donc de les déssiner après 
    const handleDownLink = (i) => {
        const { links } = data;
        const listElmt = Object.keys(links);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt + 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = links[elt];
        });
        for (const member in links)
            delete links[member];
        Object.assign(links, new_cat);
        set_data(Object.assign({}, data));
    };
    //=================FONCTION POUR TEST VALEUR MULTI SELECT LABEL===========================
    const allLabelHeight = () => {
        let display_size = true;
        let size = 25;
        if (multi_selected_label.current.length != 0) {
            size = multi_selected_label.current[0].label_height;
        }
        multi_selected_label.current.map((d) => {
            display_size = (d.label_height == size) ? display_size : false;
        });
        return (display_size) ? size : -1;
    };
    const allLabelWidth = () => {
        let display_size = true;
        let size = 25;
        if (multi_selected_label.current.length != 0) {
            size = multi_selected_label.current[0].label_width;
        }
        multi_selected_label.current.map((d) => {
            display_size = (d.label_width == size) ? display_size : false;
        });
        return (display_size) ? size : -1;
    };
    const allLabelTransparent = () => {
        let transparent = false;
        multi_selected_label.current.map((d) => {
            transparent = (d.transparent) ? true : transparent;
        });
        return transparent;
    };
    const allLabelBorderTransparent = () => {
        let transparent = false;
        multi_selected_label.current.map((d) => {
            transparent = (d.transparent_border) ? true : transparent;
        });
        return transparent;
    };
    const allNodeLabelVert = (arg, pos) => {
        let all_same = true;
        if (multi_selected_label.current.length > 0) {
            if (arg == 'vert') {
                multi_selected_label.current.map(d => all_same = (d.position_vert !== pos) ? false : all_same);
            }
            else if (arg == 'horiz') {
                multi_selected_label.current.map(d => all_same = (d.position_horiz !== pos) ? false : all_same);
            }
        }
        else {
            all_same = false;
        }
        return all_same;
    };
    const allLabelFontSize = () => {
        let display_size = true;
        let size = 1;
        if (multi_selected_label.current.length != 0) {
            size = multi_selected_label.current[0].font_size;
        }
        multi_selected_label.current.map((d) => {
            display_size = (d.font_size == size) ? display_size : false;
        });
        return (display_size) ? size : -1;
    };
    const allLabelTextBold = () => {
        let bold = false;
        multi_selected_label.current.map((d) => {
            bold = (d.font_weight) ? true : bold;
        });
        return bold;
    };
    const allLabelTextItalic = () => {
        let italic = false;
        multi_selected_label.current.map((d) => {
            italic = (d.font_style) ? true : italic;
        });
        return italic;
    };
    const allLabelTextUpper = () => {
        let up = false;
        multi_selected_label.current.map((d) => {
            up = (d.font_uppercase) ? true : up;
        });
        return up;
    };
    const label_libre_align_vert = () => {
        multi_selected_label.current.map(d => {
            switch (d.position_vert) {
                case 'milieu':
                    d.y_label = d.label_height / 2;
                    break;
                case 'bas':
                    d.y_label = d.label_height - 3;
                    break;
                default:
                    d.y_label = d.label_height - 3;
                    break;
            }
        });
    };
    const label_libre_align_horiz = () => {
        multi_selected_label.current.map(d => {
            switch (d.position_horiz) {
                case 'milieu':
                    d.x_label = d.label_width / 2;
                    break;
                case 'droite':
                    d.x_label = d.label_width - 3;
                    break;
                default:
                    d.x_label = d.label_width - 3;
                    break;
            }
        });
    };
    //Dépalce la place des labels libres sélectionnés vers le debut dans le tableau de liens de data
    //Permet donc de les déssiner après 
    const handleUplabel = (i) => {
        const { labels } = data;
        const listElmt = Object.keys(labels);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt - 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = labels[elt];
        });
        for (const member in labels)
            delete labels[member];
        Object.assign(labels, new_cat);
        set_data(Object.assign({}, data));
    };
    //Dépalce la place des labels libres sélectionnés vers la fin dans le tableau de liens de data
    //Permet donc de les déssiner après 
    const handleDownlabel = (i) => {
        const { labels } = data;
        const listElmt = Object.keys(labels);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt + 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = labels[elt];
        });
        for (const member in labels)
            delete labels[member];
        Object.assign(labels, new_cat);
        set_data(Object.assign({}, data));
    };
    const [showPreference, setShowPreference] = (0, react_1.useState)(false);
    const preferenceCheck = (str) => {
        if (!data.accordeonToShow.includes(str)) {
            data.accordeonToShow.push(str);
        }
        else {
            const posElemt = data.accordeonToShow.indexOf(str);
            data.accordeonToShow.splice(posElemt, 1);
        }
    };
    const modalPreference = (react_1.default.createElement(react_bootstrap_1.Modal, { show: showPreference, onHide: () => { setShowPreference(false); } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Pr\u00E9ferences")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 }, "Charger une police d'icones"),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                    react_1.default.createElement(react_bootstrap_1.FormControl
                    //Permet de charger les icon, pour l'instant permet de formater les données issus de https://icomoon.io/
                    , { 
                        //Permet de charger les icon, pour l'instant permet de formater les données issus de https://icomoon.io/
                        type: 'file', onChange: (evt) => {
                            const files = evt.target.files;
                            const reader = new FileReader();
                            reader.onload = (() => {
                                return (e) => {
                                    const result = String(e.target.result);
                                    const js = JSON.parse(result);
                                    js.icons.map((d) => {
                                        const name = d.properties.name;
                                        data.icon_catalog[name] = d.icon.paths[0];
                                    });
                                };
                            })();
                            reader.readAsText(files[0]);
                            set_data(data);
                        } }))),
            react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 } }),
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: (mode_visualisation) ? 'success' : 'outline-success', onClick: () => {
                        data.accordeonToShow = ['Vis', 'Leg'];
                        set_mode_selection('s');
                        set_mode_visualisation(true);
                        set_data(Object.assign({}, data));
                    } }, "Visualisation"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: (mode_visualisation) ? 'outline-warning' : 'warning', onClick: () => {
                        set_mode_visualisation(false);
                    } }, "Construction")),
            react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 } }),
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: mode_visualisation, onClick: () => {
                        data.accordeonToShow = ['MEP'];
                        set_data(Object.assign({}, data));
                    } }, "Simple"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', disabled: mode_visualisation, onClick: () => {
                        data.accordeonToShow = ['MEP', 'EN', 'EF', 'ED', 'LL', 'Vis', 'Leg'];
                        set_data(Object.assign({}, data));
                    } }, "Expert")),
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('MEP'), type: "checkbox", label: "Mise en page", onChange: () => {
                        preferenceCheck('MEP');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { checked: !mode_visualisation, disabled: true, type: "checkbox", label: "Noeuds" }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('EN'), type: "checkbox", label: "\u00C9tiquettes Noeuds", onChange: () => {
                        react_bootstrap_1.Form.Check;
                        preferenceCheck('EN');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { checked: !mode_visualisation, disabled: true, type: "checkbox", label: "Flux" }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('EF'), type: "checkbox", label: "\u00C9tiquettes Flux", onChange: () => {
                        preferenceCheck('EF');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('ED'), type: "checkbox", label: "\u00C9tiquettes Donn\u00E9es", onChange: () => {
                        preferenceCheck('ED');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('LL'), type: "checkbox", label: "Label Libres", onChange: () => {
                        preferenceCheck('LL');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('Vis'), type: "checkbox", label: "Storytelling", onChange: () => {
                        preferenceCheck('Vis');
                        set_data(Object.assign({}, data));
                    } }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { disabled: mode_visualisation, checked: data.accordeonToShow.includes('Leg'), type: "checkbox", label: "L\u00E9gends", onChange: () => {
                        preferenceCheck('Leg');
                        set_data(Object.assign({}, data));
                    } }))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => { setShowPreference(false); } }, "Close"))));
    //Modal et fonctions pour l'édition et affectation des styles de noeud
    const [showStyle, setShowStyle] = (0, react_1.useState)(false);
    const showStyleEdition = () => {
        setShowStyle(true);
    };
    const closeStyleEdition = () => {
        setShowStyle(false);
    };
    const applyStyleToNodes = () => {
        const style = data.style_node[selected_style_node];
        Object.values(data.nodes).filter(d => d.style != '' && d.style == selected_style_node).map(d => {
            //Style Noeud
            d.shape_visible = style.shape_visible;
            d.color = style.color;
            d.shape = style.shape;
            d.node_width = style.node_width;
            d.node_height = style.node_height;
            //Syle label
            d.label_visible = style.label_visible;
            d.show_value = style.show_value;
            d.display_style.font_size = style.display_style.font_size;
            d.display_style.bold = style.display_style.bold;
            d.display_style.uppercase = style.display_style.uppercase;
            d.display_style.italic = style.display_style.italic;
            d.display_style.label_box_width = style.display_style.label_box_width;
            d.display_style.label_vert = style.display_style.label_vert;
            d.display_style.label_horiz = style.display_style.label_horiz;
            d.display_style.font_family = style.display_style.font_family;
        });
        set_data(Object.assign({}, data));
    };
    const cut_name = (t, n) => {
        return (t.length > n) ? t.slice(0, n) + '...' : t;
    };
    const viewOfData = () => {
        const d = JSON.parse(JSON.stringify(data.view.filter(d => d.id == view)[0].view_data));
        d.view = JSON.parse(JSON.stringify(data.view));
        return d;
    };
    const [selected_style_node, set_selected_style_node] = (0, react_1.useState)('default');
    // const [style_to_apply, set_style_to_apply] = useState('default')
    const modalStyleNode = (react_1.default.createElement(react_bootstrap_1.Modal, { show: showStyle, onHide: closeStyleEdition, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Style")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            const new_style = (0, SankeyUtils_1.default_node)(data);
                            new_style.name = 'New Style';
                            const new_id = 'style_node_' + String(new Date().getTime());
                            data.style_node[new_id] = new_style;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, (selected_style_node != '') ? cut_name(data.style_node[selected_style_node].name, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_node).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => { set_selected_style_node(d); } }, data.style_node[d].name));
                        })))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', disabled: selected_style_node == 'default', onClick: () => {
                            delete data.style_node[selected_style_node];
                            set_selected_style_node((Object.keys(data.style_node).length > 0) ? Object.keys(data.style_node)[0] : '');
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning", onClick: applyStyleToNodes }, "Appliquer le style aux noeuds"))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Nom Style")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { value: (selected_style_node != '') ? data.style_node[selected_style_node].name : '', onChange: evt => {
                            data.style_node[selected_style_node].name = evt.target.value;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "nodes_desc", id: "node_attributes" },
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "nodes_desc", title: "Apparence" },
                        react_1.default.createElement(react_bootstrap_1.Form, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Visibilit\u00E9")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: (selected_style_node != '') ? data.style_node[selected_style_node].shape_visible : false, onChange: evt => {
                                            data.style_node[selected_style_node].shape_visible = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Couleur")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'color', value: (selected_style_node != '') ? data.style_node[selected_style_node].color : '#ffffff', onChange: evt => {
                                            data.style_node[selected_style_node].color = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Forme")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "ellipse", type: 'radio', label: 'Cercle', checked: (selected_style_node != '') ? data.style_node[selected_style_node].shape == 'ellipse' : false, onChange: evt => {
                                            data.style_node[selected_style_node].shape = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "rect", type: 'radio', label: 'Rectangle', checked: (selected_style_node != '') ? data.style_node[selected_style_node].shape == 'rect' : false, onChange: evt => {
                                            data.style_node[selected_style_node].shape = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })))),
                        react_1.default.createElement(react_bootstrap_1.Form, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Taille minimum Largeur")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: (selected_style_node != '') ? data.style_node[selected_style_node].node_width : 0, onChange: evt => {
                                            data.style_node[selected_style_node].node_width = +evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null, "px")),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Taille minimum Hauteur")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: (selected_style_node != '') ? data.style_node[selected_style_node].node_height : 0, onChange: evt => {
                                            data.style_node[selected_style_node].node_height = +evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null, "px")))),
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "label_desc", title: "Labels" },
                        react_1.default.createElement(react_bootstrap_1.Form, null,
                            react_1.default.createElement(react_bootstrap_1.Row, null,
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 }, "Police des labels"),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                                    react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                                            data.style_node[selected_style_node].display_style.font_family = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } }, data.display_style.font_family.map((d) => {
                                        return react_1.default.createElement("option", { key: 'ff-' + d, value: d, selected: d == data.style_node[selected_style_node].display_style.font_family }, d);
                                    })))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 }, "Visibilit\u00E9"),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: (selected_style_node != '') ? data.style_node[selected_style_node].label_visible : false, onChange: evt => {
                                            data.style_node[selected_style_node].label_visible = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Afficher la valeur du noeud")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: (selected_style_node != '') ? data.style_node[selected_style_node].show_value : false, onChange: evt => {
                                            data.style_node[selected_style_node].show_value = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Taille police")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { min: 11, max: 20, type: 'number', value: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.font_size : 0, onChange: evt => {
                                            data.style_node[selected_style_node].display_style.font_size = +evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null, "px")),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Police")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Gras', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.bold : false, onChange: evt => {
                                            data.style_node[selected_style_node].display_style.bold = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Majuscule', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.uppercase : false, onChange: evt => {
                                            data.style_node[selected_style_node].display_style.uppercase = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Italique', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.italic : false, onChange: evt => {
                                            data.style_node[selected_style_node].display_style.italic = evt.target.checked;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Coupure des labels")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: 'number', placeholder: '110', min: 0, max: 500, value: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_box_width : 0, onChange: evt => {
                                            data.style_node[selected_style_node].display_style.label_box_width = +evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null, "px")),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position vertical")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Haut', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_vert == 'haut' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_vert = 'haut';
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Milieu', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_vert == 'milieu' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_vert = 'milieu';
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Bas', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_vert == 'bas' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_vert = 'bas';
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position horizontal")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Gauche', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_horiz == 'gauche' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_horiz = 'gauche';
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Milieu', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_horiz == 'milieu' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_horiz = 'milieu';
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Droite', checked: (selected_style_node != '') ? data.style_node[selected_style_node].display_style.label_horiz == 'droite' : false, onChange: () => {
                                            data.style_node[selected_style_node].display_style.label_horiz = 'droite';
                                            set_data(Object.assign({}, data));
                                        } }))))))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                "Noeuds affect\u00E9s au style :",
                Object.values(data.nodes).filter(d => d.style == selected_style_node).map(d => d.name).join('/'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: closeStyleEdition }, "Close"))));
    const apply_style_to_nodes = () => {
        const style = data.style_node[style_to_apply];
        multi_selected_nodes.current.map(d => {
            //Style Noeud
            d.shape_visible = style.shape_visible;
            d.color = style.color;
            d.shape = style.shape;
            d.node_width = style.node_width;
            d.node_height = style.node_height;
            //Syle label
            d.label_visible = style.label_visible;
            d.show_value = style.show_value;
            d.display_style.font_size = style.display_style.font_size;
            d.display_style.bold = style.display_style.bold;
            d.display_style.uppercase = style.display_style.uppercase;
            d.display_style.italic = style.display_style.italic;
            d.display_style.label_box_width = style.display_style.label_box_width;
            d.display_style.label_vert = style.display_style.label_vert;
            d.display_style.label_horiz = style.display_style.label_horiz;
            d.display_style.font_family = style.display_style.font_family;
        });
        set_data(Object.assign({}, data));
    };
    const style_of_selected_nodes = () => {
        let style_to_display = 'Aucun';
        if (multi_selected_nodes.current.length != 0) {
            style_to_display = multi_selected_nodes.current[0].style;
            let inchangee = true;
            multi_selected_nodes.current.map(d => {
                inchangee = (d.style == style_to_display) ? inchangee : false;
            });
            if (style_to_display != '' && style_to_display !== undefined) {
                return (inchangee) ? cut_name(data.style_node[style_to_display].name, 20) : 'Multiple style parmi les noeuds sélectionnés';
            }
            else {
                return 'Aucun';
            }
        }
        else {
            return style_to_display;
        }
    };
    //Modal et fonctions pour l'edition et affectation des style de flux
    const [showStyleLink, setShowStyleLink] = (0, react_1.useState)(false);
    const showStyleEditionLink = () => {
        setShowStyleLink(true);
    };
    const closeStyleEditionLink = () => {
        setShowStyleLink(false);
    };
    const applyStyleToLinks = () => {
        const style = data.style_link[selected_style_link];
        Object.values(data.links).filter(d => d.style != '' && d.style == selected_style_link).map(d => {
            d.recycling = style.recycling;
            d.orientation = style.orientation;
            d.arrow = style.arrow;
            // display_attribute
            d.label_position = style.label_position;
            d.orthogonal_label_position = style.orthogonal_label_position;
            d.label_on_path = style.label_on_path;
            d.label_visible = style.label_visible;
            d.text_color = style.text_color;
            d.color = style.color;
            d.gradient = style.gradient;
            d.curvature = style.curvature;
            d.curved = style.curved;
        });
        set_data(Object.assign({}, data));
    };
    const apply_style_to_selected_links = () => {
        const style = data.style_link[style_to_apply_to_link];
        multi_selected_links.current.map(d => {
            // type of link
            d.recycling = style.recycling;
            d.orientation = style.orientation;
            d.arrow = style.arrow;
            // display_attribute
            d.label_position = style.label_position;
            d.orthogonal_label_position = style.orthogonal_label_position;
            d.label_on_path = style.label_on_path;
            d.label_visible = style.label_visible;
            d.text_color = style.text_color;
            d.color = style.color;
            d.gradient = style.gradient;
            d.curvature = style.curvature;
            d.curved = style.curved;
        });
    };
    const [selected_style_link, set_selected_style_link] = (0, react_1.useState)('default');
    const [style_to_apply_to_link, set_style_to_apply_to_link] = (0, react_1.useState)('default');
    const modalStyleLink = (react_1.default.createElement(react_bootstrap_1.Modal, { show: showStyleLink, onHide: closeStyleEditionLink, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Style")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            const new_style = (0, SankeyUtils_1.default_link)(data);
                            new_style.idLink = 'New Style';
                            const new_id = 'style_link_' + String(new Date().getTime());
                            data.style_link[new_id] = new_style;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, (selected_style_link != '') ? cut_name(data.style_link[selected_style_link].idLink, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_link).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => { set_selected_style_link(d); } }, data.style_link[d].idLink));
                        })))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', disabled: selected_style_link == 'default', onClick: () => {
                            delete data.style_link[selected_style_link];
                            set_selected_style_link((Object.keys(data.style_link).length > 0) ? Object.keys(data.style_link)[0] : '');
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning", onClick: applyStyleToLinks }, "Appliquer le style aux flux"))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Nom Style")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { value: (selected_style_link != '') ? data.style_link[selected_style_link].idLink : '', onChange: evt => {
                            data.style_link[selected_style_link].idLink = evt.target.value;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                    react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "flux_attributes", id: "settings-layout" },
                        react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_attributes", title: "Apparence" },
                            react_1.default.createElement(react_bootstrap_1.Form, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Couleur:")),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", value: data.style_link[selected_style_link].color, onChange: evt => {
                                                // selected_link.current.color = evt.target.value
                                                const color = evt.target.value;
                                                data.style_link[selected_style_link].color = color;
                                                set_data(Object.assign({}, data));
                                            } }))),
                                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Gradient:")),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "checkbox", checked: data.style_link[selected_style_link].gradient, onChange: evt => {
                                                // selected_link.current.color = evt.target.value
                                                data.style_link[selected_style_link].gradient = evt.target.checked;
                                                set_data(Object.assign({}, data));
                                            } }))),
                                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Type:")),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Courbe', checked: data.style_link[selected_style_link].curved, onChange: evt => {
                                                data.style_link[selected_style_link].curved = evt.target.checked;
                                                set_data(Object.assign({}, data));
                                            } })),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Fl\u00E8che', checked: data.style_link[selected_style_link].arrow, onChange: evt => {
                                                data.style_link[selected_style_link].arrow = evt.target.checked;
                                                set_data(Object.assign({}, data));
                                            } })),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Recyclage', checked: (data.style_link[selected_style_link].recycling) ? true : false, onChange: evt => {
                                                data.style_link[selected_style_link].recycling = evt.target.checked;
                                                set_data(Object.assign({}, data));
                                            } }))),
                                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Courbure")),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 1, step: 0.01, type: 'number', value: data.style_link[selected_style_link].curvature, onChange: evt => {
                                                data.style_link[selected_style_link].curvature = +evt.target.value;
                                                set_data(Object.assign({}, data));
                                            } })),
                                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, selected_link.current.curvature)),
                                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, name: 'orientation', type: 'radio', label: 'Horiz-Horiz', value: 'hh', checked: data.style_link[selected_style_link].orientation == 'hh', onChange: () => {
                                                data.style_link[selected_style_link].orientation = 'hh';
                                                set_data(Object.assign({}, data));
                                            } }),
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, name: 'orientation', type: 'radio', label: 'Vert-Vert', value: 'vv', checked: data.style_link[selected_style_link].orientation == 'vv', onChange: () => {
                                                data.style_link[selected_style_link].orientation == 'vv';
                                                set_data(Object.assign({}, data));
                                            } }),
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, name: 'orientation', type: 'radio', label: 'Vert-Horiz', value: 'vh', checked: data.style_link[selected_style_link].orientation == 'vh', onChange: () => {
                                                data.style_link[selected_style_link].orientation = 'vh';
                                                set_data(Object.assign({}, data));
                                            } }),
                                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, name: 'orientation', type: 'radio', label: 'Horiz-Vert', value: 'hv', checked: data.style_link[selected_style_link].orientation == 'hv', onChange: () => {
                                                data.style_link[selected_style_link].orientation = 'hv';
                                                set_data(Object.assign({}, data));
                                            } }))))),
                        react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "label", title: "Label" },
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'black', type: 'radio', label: 'Label en noir', checked: data.style_link[selected_style_link].text_color == 'black', onChange: () => {
                                            data.style_link[selected_style_link].text_color = 'black';
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'white', type: 'radio', label: 'Label blanc', checked: data.style_link[selected_style_link].text_color == 'white', onChange: (evt) => {
                                            data.style_link[selected_style_link].text_color = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'same_color', type: 'radio', label: 'Label en couleur', checked: data.style_link[selected_style_link].text_color == 'color', onChange: () => {
                                            data.style_link[selected_style_link].text_color = data.style_link[selected_style_link].color;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Label visible', checked: data.style_link[selected_style_link].label_visible, onChange: evt => {
                                        data.style_link[selected_style_link].label_visible = evt.target.checked;
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position laterale:")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'beginning', type: 'radio', label: 'D\u00E9but', checked: data.style_link[selected_style_link].label_position == 'beginning', onChange: evt => {
                                            data.style_link[selected_style_link].label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', type: 'radio', label: 'Milieu', checked: data.style_link[selected_style_link].label_position == 'middle', onChange: evt => {
                                            data.style_link[selected_style_link].label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'end', type: 'radio', label: 'Fin', checked: data.style_link[selected_style_link].label_position == 'end', onChange: evt => {
                                            data.style_link[selected_style_link].label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Attach\u00E9 au flux', disabled: selected_link.current.label_position === 'frozen', checked: data.style_link[selected_style_link].label_on_path, onChange: evt => {
                                        data.style_link[selected_style_link].label_on_path = evt.target.checked;
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position orthogonale:")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'below', type: 'radio', label: 'Dessous', checked: data.style_link[selected_style_link].orthogonal_label_position == 'below', onChange: evt => {
                                            data.style_link[selected_style_link].orthogonal_label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', type: 'radio', label: 'Milieu', checked: data.style_link[selected_style_link].orthogonal_label_position == 'middle', onChange: evt => {
                                            data.style_link[selected_style_link].orthogonal_label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'above', type: 'radio', label: 'Dessus', checked: data.style_link[selected_style_link].orthogonal_label_position == 'above', onChange: evt => {
                                            data.style_link[selected_style_link].orthogonal_label_position = evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } }))))))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                "Noeuds affect\u00E9s au style :",
                Object.values(data.links).filter(d => d.style == selected_style_link).map(d => d.idSource + '-->' + d.idTarget).join('/'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: closeStyleEditionLink }, "Close"))));
    const [show_publish_dialog, set_show_publish_dialog] = (0, react_1.useState)(false);
    const publishImpl = (file_path) => {
        // const form_data = new FormData()
        // form_data.append('file', input_file)
        const path = window.location.href;
        const url = path + url_prefix + 'sankey/publish';
        const new_data = JSON.parse(JSON.stringify(data));
        new_data.file_name = file_path;
        const fetchData = {
            method: 'POST',
            body: JSON.stringify(new_data, null, 2)
        };
        fetch(url, fetchData).then(response => {
            if (!response.ok) {
                alert(response);
            }
        });
        set_show_publish_dialog(false);
    };
    //Change le style des flux sélectionnés
    const style_of_selected_links = () => {
        let style_to_display = 'Aucun';
        if (multi_selected_links.current.length != 0) {
            style_to_display = multi_selected_links.current[0].style;
            let inchangee = true;
            multi_selected_links.current.map(d => {
                inchangee = (d.style == style_to_display) ? inchangee : false;
            });
            if (style_to_display != '' && style_to_display !== undefined) {
                return (inchangee) ? cut_name(data.style_link[style_to_display].idLink, 25) : 'Multiple style parmi les noeuds sélectionnés';
            }
            else {
                return 'Aucun';
            }
        }
        else {
            return style_to_display;
        }
    };
    //Modal pour les raccourcis clavier
    const [showShortcut, setshowShortcut] = (0, react_1.useState)(false);
    const modalShortcut = (react_1.default.createElement(react_bootstrap_1.Modal, { size: 'lg', show: showShortcut, onHide: () => setshowShortcut(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Raccourci Clavier")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("p", null, "Fonctionnement des clics :"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "CTRL + Clic (noeuds) :"),
                " S\u00E9lectionne le noeuds click dans l'onglet \"",
                react_1.default.createElement("b", null, "Noeuds"),
                "\" du menu"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "CTRL + Clic (flux) :"),
                " S\u00E9lectionne le flux click dans l'onglet \"",
                react_1.default.createElement("b", null, "Flux"),
                "\" du menu"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Suppr"),
                " ou ",
                react_1.default.createElement("b", null, "Retour arri\u00E8re :"),
                " Supprime les noeuds et flux s\u00E9lectionn\u00E9s"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Clic (en dehors d'un noeud/flux) :"),
                "  D\u00E9s\u00E9lectionne les noeuds et flux s\u00E9lectionn\u00E9s"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Clic droit (noeuds) :"),
                "  Agr\u00E9ge le noeud"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Alt Clic droit (noeuds) :"),
                "  D\u00E9sagr\u00E9ge le noeud"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Alt Clic (label noeuds) :"),
                "  D\u00E9place le label"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "CTRL + S :"),
                " Sauvegarde la configuration actuelle dans une vue, qui peut ensuite \u00EAtre visualis\u00E9 dans le Menu Vue "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Fl\u00E8che du clavier :"),
                " Permet de d\u00E9placer les noeuds s\u00E9lectionn\u00E9s en fonction du grillage  "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Echap :"),
                " Ferme le Menu si il est ouvert ")),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setshowShortcut(false) }, "Close"))));
    const [showHelp, setshowHelp] = (0, react_1.useState)(false);
    const modalHelp = (react_1.default.createElement(react_bootstrap_1.Modal, { size: 'lg', show: showHelp, onHide: () => setshowHelp(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Aide")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setshowHelp(false) }, "Close"))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !data.static_sankey ? (modalStyleNode) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !data.static_sankey ? (modalPreference) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !data.static_sankey ? (modalStyleLink) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !data.static_sankey ? (modalShortcut) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !data.static_sankey ? (modalHelp) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(react_bootstrap_1.Navbar, { className: 'bg-light', fixed: 'top', style: { 'display': 'block' } },
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'MenuNavigation' },
                react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { href: "#" },
                    react_1.default.createElement("img", { src: logo, width: logo_width }),
                    " ",
                    app_name,
                    " "),
                !window.SankeyToolsStatic ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Nav, null,
                        react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: "Fichiers", id: "files" },
                            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'start', id: 'ouvrir', title: "Ouvrir" },
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                                        if (_load_json.current) {
                                            _load_json.current.name = '';
                                            _load_json.current.click();
                                        }
                                    } }, "JSON"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", ref: _load_json, style: { display: 'none' }, onChange: (evt) => {
                                        const files = evt.target.files;
                                        const reader = new FileReader();
                                        reader.onload = (() => {
                                            return (e) => {
                                                let result = String(e.target.result);
                                                const new_data = (0, SankeyUtils_1.default_sankey_data)();
                                                result = result.split('<br>').join('\\\\n');
                                                const result_data = JSON.parse(result);
                                                Object.assign(new_data, result_data);
                                                if (result_data.version === undefined) {
                                                    new_data.version = undefined;
                                                }
                                                (0, SankeyConvert_1.convert_data)(new_data);
                                                (0, SankeyUtils_1.set_nodes_level)(new_data, new_data.nodes, new_data.agregation.level, true);
                                                set_data(new_data);
                                                const test = document.getElementsByClassName('navbar');
                                                let margin_top = 0;
                                                if (test && test.length > 0) {
                                                    margin_top = test[0].getBoundingClientRect().height;
                                                    d3.select('#svg-container').style('margin-top', margin_top + 'px');
                                                }
                                                // if ( data.agregation.level === -1 ) {
                                                //   localStorage.setItem('initial_data', LZString.compress((JSON.stringify(new_data))))
                                                // }
                                            };
                                        })();
                                        reader.readAsText(files[0]);
                                    } }),
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_excel_dialog(true) }, "Excel"),
                                open_menu),
                            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'start', id: 'enregistrer', title: "Enregistrer" },
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: clickSaveDiagram }, "JSON"),
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: clickSaveExcel }, "Excel"),
                                save_menu),
                            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'start', id: 'exporter', title: "Exporter" },
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: clickSaveSVG }, "Exporter SVG"),
                                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: clickSavePDF }, "Exporter PDF")),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => { setShowPreference(true); } }, "Pr\u00E9f\u00E9rences")),
                        react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: 'edition', title: "Edition" },
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: reinitialization }, "R\u00E9initialiser"),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_publish_dialog(true) }, "Publier"),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_apply_layout(true) }, "Appliquer mise en page"),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: showStyleEdition }, "Edition Style Noeud"),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: showStyleEditionLink }, "Edition Style Flux")),
                        edition_menu,
                        formations_menu ? (react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: "Formations", id: "formation" }, formations_menu)) : (react_1.default.createElement(react_1.default.Fragment, null)),
                        react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: "Exemples", id: "exemples" }, example_menu),
                        react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: 'Aide', title: "Aide" },
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => setshowShortcut(true) }, "Raccourci Clavier"),
                            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => setshowHelp(true) }, "Aide Suppl\u00E9mentaire")),
                        !data.static_sankey ? (react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "mb-2", style: { 'width': (show_nav) ? '537px' : '80px' } },
                            react_1.default.createElement(react_bootstrap_1.ToggleButton, { ref: button_ref, id: "toggle-check", type: "checkbox", variant: "outline-primary", checked: show_nav, onChange: (e) => { setChecked(e.currentTarget.checked); }, onClick: toggleShow, value: "1" }, menuButton()))) : (react_1.default.createElement(react_1.default.Fragment, null)),
                        right_menu))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("h2", null, window.sankey.header),
                    react_1.default.createElement("br", null)))),
            (view == 'none') ? react_1.default.createElement(SankeyEdition_1.default, { data: data, set_data: set_data, additional_selector: additional_selector, mode_selection: mode_selection, set_mode_selection: set_mode_selection, mode_visualisation: mode_visualisation, set_current_filter: set_current_filter }) : react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Col, lg: 'auto' },
                        react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: (!(mode_selection == 's')) ? 'outline-info' : 'info', onClick: () => {
                                    const ev = document;
                                    const tmp = { key: 'p' };
                                    if (ev.onkeydown) {
                                        ev.onkeydown(tmp);
                                    }
                                } },
                                react_1.default.createElement(fa_1.FaPlay, null)),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-success', onClick: () => {
                                    const ev = document;
                                    const tmp = { key: 'ArrowUp' };
                                    if (ev.onkeydown) {
                                        ev.onkeydown(tmp);
                                    }
                                } },
                                react_1.default.createElement(fa_1.FaBackward, null)),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-warning', onClick: () => {
                                    const ev = document;
                                    const tmp = { key: 'ArrowDown' };
                                    if (ev.onkeydown) {
                                        ev.onkeydown(tmp);
                                    }
                                } },
                                react_1.default.createElement(fa_1.FaForward, null))))))),
        (show_nav) ? react_1.default.createElement(react_bootstrap_1.Offcanvas, Object.assign({ className: 'sankey-menu', show: true, placement: 'end' /*onHide={set_show_nav(false)}*/ }, props, { style: { 'width': '540px', 'marginTop': '71px', 'marginRight': '15px' } }),
            react_1.default.createElement(react_bootstrap_1.Offcanvas.Body, { style: { 'padding': '0px 0px 0px 0px' } },
                react_1.default.createElement(Accordion_1.default, { ref: accordion_ref, activeKey: nav_item_active },
                    react_1.default.createElement(Accordion_1.default.Item, { id: 'MEP', style: { 'display': (view == 'none' && data.accordeonToShow.includes('MEP')) ? 'block' : 'none' }, eventKey: "1", onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === '1') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('1');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "Mise en page"),
                        react_1.default.createElement(Accordion_1.default.Body, null, settings_edition)),
                    react_1.default.createElement(Accordion_1.default.Item, { style: { 'display': (view == 'none' && !mode_visualisation) ? 'block' : 'none' }, eventKey: "2", id: "Nodes", onClick: evt => {
                            if (evt.target.className === 'accordion-button' && evt.target.textContent === 'Noeuds' && nav_item_active === '2') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('2');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "Noeuds"),
                        react_1.default.createElement(Accordion_1.default.Body, { style: { padding: '0px' } },
                            react_1.default.createElement(Accordion_1.default, { ref: nodes_accordion_ref, activeKey: sub_nav_item_active },
                                react_1.default.createElement(Accordion_1.default.Item, { style: { 'display': (view == 'none' && data.accordeonToShow.includes('EN')) ? 'block' : 'none' }, eventKey: "EtiquetteNoeud", onClick: evt => {
                                        if (evt.target.className === 'accordion-button') {
                                            set_sub_nav_item_active('');
                                            set_nav_item_active('2');
                                            set_show_nav(true);
                                        }
                                        else {
                                            set_sub_nav_item_active('EtiquetteNoeud');
                                            set_nav_item_active('2');
                                            set_show_nav(true);
                                        }
                                    } },
                                    react_1.default.createElement(Accordion_1.default.Header, { style: { marginLeft: '25px' /*,padding:'10px' */ } }, "\u00C9tiquettes Noeuds"),
                                    react_1.default.createElement(Accordion_1.default.Body, null, settings_edition_node_tags)),
                                react_1.default.createElement(Accordion_1.default.Item, { eventKey: 'editionNoeud', onClick: evt => {
                                        if (evt.target.className === 'accordion-button') {
                                            set_sub_nav_item_active('');
                                            set_nav_item_active('2');
                                            set_show_nav(true);
                                        }
                                        else {
                                            set_sub_nav_item_active('editionNoeud');
                                            set_nav_item_active('2');
                                            set_show_nav(true);
                                        }
                                    } },
                                    react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, "Edition Noeuds"),
                                    react_1.default.createElement(Accordion_1.default.Body, null,
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                                                        set_style_to_apply('default');
                                                        add_new_node();
                                                    } },
                                                    react_1.default.createElement(fa_1.FaPlus, null))),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, dropdownMultiNode()),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', disabled: multi_selected_nodes.current.length == 0, onClick: () => {
                                                        //Boutton pour supprimer le noeud selectionné
                                                        multi_selected_nodes.current.map(d => (0, SankeyUtils_1.delete_node)(data, d));
                                                        selected_node.current = (0, SankeyUtils_1.default_node)(data);
                                                        multi_selected_nodes.current = [];
                                                        // Object.values(data.nodes).forEach( n => 
                                                        //   d3.select('#' + n.idNode).attr('stroke-width',0)
                                                        // )
                                                        // setForceUpdate(!forceUpdate)
                                                        set_data(Object.assign({}, data));
                                                    } },
                                                    react_1.default.createElement(fa_1.FaMinus, null)))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Style:")),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                                                react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                                                    react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, style_of_selected_nodes()),
                                                    react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                                                        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                                                                set_style_to_apply('');
                                                                multi_selected_nodes.current.map(n => {
                                                                    n.style = '';
                                                                });
                                                                set_data(Object.assign({}, data));
                                                            } }, 'Aucun'),
                                                        Object.keys(data.style_node).map((d, i) => {
                                                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => {
                                                                    set_style_to_apply(d);
                                                                    multi_selected_nodes.current.map(n => {
                                                                        n.style = d;
                                                                    });
                                                                    set_data(Object.assign({}, data));
                                                                } }, data.style_node[d].name));
                                                        })))),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'info', onClick: () => {
                                                        apply_style_to_nodes();
                                                    } }, "Appliquer Style"))),
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Nom")),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                                                react_1.default.createElement(react_bootstrap_1.FormControl, { value: (multi_selected_nodes.current.length != 1) ? '' : multi_selected_nodes.current[0].name, onChange: evt => {
                                                        if (multi_selected_nodes.current.length != 1) {
                                                            return;
                                                        }
                                                        multi_selected_nodes.current[0].name = evt.target.value;
                                                        const d = multi_selected_nodes.current[0];
                                                        d3.select('#' + d.idNode + '_text').text(evt.target.value);
                                                        const wrap = (0, d3_textwrap_1.textwrap)()
                                                            .bounds({ height: 100, width: (d.display_style.label_box_width != 0) ? d.display_style.label_box_width : 110 })
                                                            .method('tspans');
                                                        d3.select('#ggg_' + d.idNode + ' text')
                                                            .call(wrap);
                                                        if (!d.x_label || data.show_structure) {
                                                            d3.selectAll('#ggg_' + d.idNode + ' text tspan').attr('dx', 0).attr('x', () => {
                                                                const width = +d3.select('#' + d.idNode).attr('width');
                                                                if (d.display_style.label_horiz == 'milieu') {
                                                                    return width / 2;
                                                                }
                                                                else if (d.display_style.label_horiz == 'droite') {
                                                                    return d.display_style.label_vert == 'milieu' ? width : 0;
                                                                }
                                                                else {
                                                                    return 0;
                                                                }
                                                            });
                                                        }
                                                        d3.selectAll('#ggg_' + d.idNode + ' text tspan').attr('dx', 0).attr('x', () => {
                                                            const width = +d3.select('#' + d.idNode).attr('width');
                                                            if (d.x_label) {
                                                                return d.x_label;
                                                            }
                                                            else if (d.display_style.label_horiz == 'milieu') {
                                                                return width / 2;
                                                            }
                                                            else if (d.display_style.label_horiz == 'droite') {
                                                                return width;
                                                            }
                                                            else {
                                                                return 0;
                                                            }
                                                        });
                                                        setForceUpdate(!forceUpdate);
                                                    }, disabled: (multi_selected_nodes.current.length == 1) ? false : true })),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 })),
                                        react_1.default.createElement(SankeyNodeEdition_1.default, { data: data, set_data: set_data, radio_selected: radio_selected, multi_selected_nodes: multi_selected_nodes, multi_selected_links: multi_selected_links }, node_edition)))))),
                    react_1.default.createElement(Accordion_1.default.Item, { style: { 'display': (view == 'none' && !mode_visualisation) ? 'block' : 'none' }, id: 'Flux', eventKey: "3", onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === '3') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('3');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "Flux"),
                        react_1.default.createElement(Accordion_1.default.Body, { style: { padding: '0px' } },
                            react_1.default.createElement(Accordion_1.default, { ref: links_accordion_ref, activeKey: sub_nav_item_active },
                                react_1.default.createElement(Accordion_1.default.Item, { eventKey: "8", style: { 'display': (view == 'none' && data.accordeonToShow.includes('EF')) ? 'block' : 'none' }, onClick: evt => {
                                        if (evt.target.className === 'accordion-button') {
                                            set_sub_nav_item_active('');
                                            set_nav_item_active('3');
                                            set_show_nav(true);
                                        }
                                        else {
                                            set_sub_nav_item_active('8');
                                            set_nav_item_active('3');
                                            set_show_nav(true);
                                        }
                                    } },
                                    react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, "\u00C9tiquettes Flux"),
                                    react_1.default.createElement(Accordion_1.default.Body, null, settings_edition_link_tags)),
                                react_1.default.createElement(Accordion_1.default.Item, { eventKey: 'editionFlux', onClick: evt => {
                                        if (evt.target.className === 'accordion-button') {
                                            set_sub_nav_item_active('');
                                            set_nav_item_active('3');
                                            set_show_nav(true);
                                        }
                                        else {
                                            set_sub_nav_item_active('editionFlux');
                                            set_nav_item_active('3');
                                            set_show_nav(true);
                                        }
                                    } },
                                    react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, "Edition Flux"),
                                    react_1.default.createElement(Accordion_1.default.Body, null,
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                                            react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center' } },
                                                react_1.default.createElement("b", null, "Param\u00E9tres g\u00E9n\u00E9raux")),
                                            react_1.default.createElement(react_bootstrap_1.Row, null,
                                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 }, "Police des labels"),
                                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                                                    react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                                                            data.display_style.link_font_family_selected = evt.target.value;
                                                            set_data(Object.assign({}, data));
                                                        } }, data.display_style.font_family.map((d) => {
                                                        return react_1.default.createElement("option", { key: 'ff-' + d, value: d, selected: d == data.display_style.link_font_family_selected }, d);
                                                    }))))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "success", onClick: () => {
                                                        add_new_link();
                                                        set_data(Object.assign({}, data));
                                                    } },
                                                    react_1.default.createElement(fa_1.FaPlus, null))),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, dropdownMultiLinks()),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "danger", onClick: () => {
                                                        multi_selected_links.current.forEach(l => (0, SankeyUtils_1.delete_link)(data, l));
                                                        multi_selected_links.current = [];
                                                        set_data(Object.assign({}, data));
                                                    } },
                                                    react_1.default.createElement(fa_1.FaMinus, null)))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Source")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.Form.Select, { disabled: multi_selected_links.current.length != 1, onChange: source_change }, addDropSource()))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Cible")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.Form.Select, { disabled: multi_selected_links.current.length != 1, onChange: target_change }, addDropCible()))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Inverser Flux")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => {
                                                        const nodes_to_reorganize = [];
                                                        multi_selected_links.current.forEach(l => {
                                                            const tmp = l.idSource;
                                                            const previous_node_s = data.nodes[l.idSource];
                                                            previous_node_s.outputLinksId.splice(previous_node_s.outputLinksId.indexOf(l.idLink), 1);
                                                            const source_node = data.nodes[l.idTarget];
                                                            l.idSource = source_node.idNode;
                                                            source_node.outputLinksId.push(l.idLink);
                                                            nodes_to_reorganize.push(source_node);
                                                            const previous_node_t = data.nodes[l.idTarget];
                                                            previous_node_t.inputLinksId.splice(previous_node_t.inputLinksId.indexOf(l.idLink), 1);
                                                            const target_node = data.nodes[tmp];
                                                            l.idTarget = target_node.idNode;
                                                            target_node.inputLinksId.push(l.idLink);
                                                            nodes_to_reorganize.push(target_node);
                                                        });
                                                        nodes_to_reorganize.forEach(n => {
                                                            (0, SankeyLayout_1.reorganize_inputLinksId)(n, true, true, data.nodes, data.links);
                                                        });
                                                        set_data(Object.assign({}, data));
                                                    } },
                                                    react_1.default.createElement(fa_1.FaArrowsAltH, null)))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "D\u00E9placement z-index flux")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                                            multi_selected_links.current.map(l => {
                                                                handleDownLink(l.idLink);
                                                            });
                                                        } },
                                                        react_1.default.createElement(fa_1.FaAngleUp, null)),
                                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                                            multi_selected_links.current.map(l => {
                                                                const i = l.idLink;
                                                                const { links } = data;
                                                                const listElmt = Object.keys(links);
                                                                const posElemt = listElmt.indexOf(i);
                                                                listElmt.splice(posElemt, 1);
                                                                listElmt.splice(listElmt.length, 0, i);
                                                                const new_cat = {};
                                                                listElmt.forEach(elt => {
                                                                    new_cat[elt] = links[elt];
                                                                });
                                                                for (const member in links)
                                                                    delete links[member];
                                                                Object.assign(links, new_cat);
                                                            });
                                                            set_data(Object.assign({}, data));
                                                        } },
                                                        react_1.default.createElement(fa_1.FaAngleDoubleUp, null)),
                                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                                            multi_selected_links.current.map(l => {
                                                                handleUpLink(l.idLink);
                                                            });
                                                        } },
                                                        react_1.default.createElement(fa_1.FaAngleDown, null)),
                                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                                            multi_selected_links.current.map(l => {
                                                                const i = l.idLink;
                                                                const { links } = data;
                                                                const listElmt = Object.keys(links);
                                                                const posElemt = listElmt.indexOf(i);
                                                                listElmt.splice(posElemt, 1);
                                                                listElmt.splice(0, 0, i);
                                                                const new_cat = {};
                                                                listElmt.forEach(elt => {
                                                                    new_cat[elt] = links[elt];
                                                                });
                                                                for (const member in links)
                                                                    delete links[member];
                                                                Object.assign(links, new_cat);
                                                            });
                                                            set_data(Object.assign({}, data));
                                                        } },
                                                        react_1.default.createElement(fa_1.FaAngleDoubleDown, null))))),
                                        react_1.default.createElement(react_bootstrap_1.Row, null,
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Style:")),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                                                react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                                                    react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, style_of_selected_links()),
                                                    react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                                                        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                                                                set_style_to_apply_to_link('');
                                                                multi_selected_links.current.map(n => {
                                                                    n.style = '';
                                                                });
                                                                set_data(Object.assign({}, data));
                                                            } }, 'Aucun'),
                                                        Object.keys(data.style_link).map((d, i) => {
                                                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => {
                                                                    set_style_to_apply_to_link(d);
                                                                    multi_selected_links.current.map(n => {
                                                                        n.style = d;
                                                                    });
                                                                    set_data(Object.assign({}, data));
                                                                } }, data.style_link[d].idLink));
                                                        })))),
                                            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'info', onClick: () => {
                                                        apply_style_to_selected_links();
                                                        set_data(Object.assign({}, data));
                                                    } }, "Appliquer Style"))),
                                        (multi_selected_links.current.length !== 0) ? (react_1.default.createElement(SankeyLinkEdition_1.default, { show: true, data: data, set_data: set_data, selected_link: selected_link, multi_selected_links: multi_selected_links }, link_edition)) : (react_1.default.createElement(react_1.default.Fragment, null))))))),
                    react_1.default.createElement(Accordion_1.default.Item, { eventKey: "dimension", style: { 'display': (view == 'none' && data.accordeonToShow.includes('ED')) ? 'block' : 'none' }, onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === 'dimension') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('dimension');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "\u00C9tiquettes Donn\u00E9es"),
                        react_1.default.createElement(Accordion_1.default.Body, null, settings_edition_data_tags)),
                    react_1.default.createElement(Accordion_1.default.Item, { eventKey: "7", id: "LL", style: { 'display': (view == 'none' && data.accordeonToShow.includes('LL')) ? 'block' : 'none' }, onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === '7') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('7');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "Labels Libres"),
                        react_1.default.createElement(Accordion_1.default.Body, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                                            const new_label = {
                                                idLabel: 'label_' + String(new Date().getTime()),
                                                name: 'Text Label ...',
                                                label_width: 100,
                                                label_height: 25,
                                                color: 'white',
                                                color_border: 'black',
                                                transparent: false,
                                                transparent_border: false,
                                                position_vert: 'milieu',
                                                position_horiz: 'gauche',
                                                font_size: 12,
                                                font_weight: false,
                                                font_style: false,
                                                font_uppercase: false,
                                                x: 50,
                                                y: 50,
                                                x_label: 50,
                                                y_label: 12,
                                            };
                                            data.labels[new_label.idLabel] = new_label;
                                            multi_selected_label.current = [new_label];
                                            set_data(Object.assign({}, data));
                                        } },
                                        react_1.default.createElement(fa_1.FaPlus, null))),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 }, dropdownMultiLabel()),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', onClick: () => {
                                            data.labels = Object.fromEntries(Object.entries(data.labels).filter(d => !multi_selected_label.current.map(l => l.idLabel).includes(d[0])));
                                            multi_selected_label.current = [];
                                            set_data(Object.assign({}, data));
                                        } },
                                        react_1.default.createElement(fa_1.FaMinus, null))),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                                    react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: multi_selected_label.current.length != 1, onClick: () => {
                                                multi_selected_label.current.map(l => {
                                                    handleDownlabel(l.idLabel);
                                                });
                                            } },
                                            react_1.default.createElement(fa_1.FaAngleUp, null)),
                                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', disabled: multi_selected_label.current.length != 1, onClick: () => {
                                                multi_selected_label.current.map(l => {
                                                    handleUplabel(l.idLabel);
                                                });
                                            } },
                                            react_1.default.createElement(fa_1.FaAngleDown, null))))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Row, null,
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, { column: true, sm: 1 }, "Text:"),
                                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 11 },
                                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 5, disabled: multi_selected_label.current.length != 1, value: multi_selected_label.current.length > 0 ? multi_selected_label.current[0].name : '', onChange: (evt) => {
                                                multi_selected_label.current.map(label => label.name = evt.target.value);
                                                set_data(Object.assign({}, data));
                                            } })))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Hauteur Label")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', min: 0, max: 1000, type: 'number', value: allLabelHeight(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.label_height = +evt.target.value);
                                            label_libre_align_vert();
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Largeur Label")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', min: 0, max: 1000, type: 'number', value: allLabelWidth(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.label_width = +evt.target.value);
                                            label_libre_align_horiz();
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Fond transparent")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: 'switch', checked: allLabelTransparent(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.transparent = evt.target.checked);
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Couleur Fond Label")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'color', value: (multi_selected_label.current.length == 1) ? multi_selected_label.current[0].color : '#ffffff', onChange: evt => {
                                            const val = evt.target.value;
                                            multi_selected_label.current.map(d => d.color = val);
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Bordure transparent")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: 'switch', checked: allLabelBorderTransparent(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.transparent_border = evt.target.checked);
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Couleur Bordure Label")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'color', value: (multi_selected_label.current.length == 1) ? multi_selected_label.current[0].color_border : '#ffffff', onChange: evt => {
                                            const val = evt.target.value;
                                            multi_selected_label.current.map(d => d.color_border = val);
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position vertical texte")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Haut', checked: allNodeLabelVert('vert', 'haut'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_vert = 'haut';
                                                // d.x_label = d.label_width / 2
                                                d.y_label = d.font_size + 3;
                                            });
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Milieu', checked: allNodeLabelVert('vert', 'milieu'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_vert = 'milieu';
                                                // d.x_label = d.label_width / 2
                                                d.y_label = d.label_height / 2;
                                            });
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Bas', checked: allNodeLabelVert('vert', 'bas'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_vert = 'bas';
                                                // d.x_label = d.label_width / 2
                                                d.y_label = d.label_height - 3;
                                            });
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Alignement texte")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Gauche', checked: allNodeLabelVert('horiz', 'gauche'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_horiz = 'gauche';
                                            });
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Centre', checked: allNodeLabelVert('horiz', 'centre'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_horiz = 'centre';
                                            });
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'radio', label: 'Droite', checked: allNodeLabelVert('horiz', 'droite'), onChange: () => {
                                            multi_selected_label.current.map(d => {
                                                d.position_horiz = 'droite';
                                            });
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Taille Police")),
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', min: 0, max: 100, type: 'number', value: allLabelFontSize(), onChange: evt => {
                                            let val = +evt.target.value;
                                            val = (val <= 0) ? 1 : val;
                                            multi_selected_label.current.map(d => d.font_size = val);
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Labels")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Gras', checked: allLabelTextBold(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.font_weight = evt.target.checked);
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Majuscule', checked: allLabelTextUpper(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.font_uppercase = evt.target.checked);
                                            set_data(Object.assign({}, data));
                                        } })),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Italique', checked: allLabelTextItalic(), onChange: evt => {
                                            multi_selected_label.current.map(d => d.font_style = evt.target.checked);
                                            set_data(Object.assign({}, data));
                                        } }))))),
                    react_1.default.createElement(Accordion_1.default.Item, { eventKey: "Visualisation", style: { 'display': (data.accordeonToShow.includes('Vis')) ? 'block' : 'none' }, onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === 'Visualisation') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('Visualisation');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "Storytelling"),
                        react_1.default.createElement(Accordion_1.default.Body, null,
                            react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "vue", id: "visualisation" },
                                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "vue", title: "Vue" },
                                    react_1.default.createElement(react_bootstrap_1.Row, null,
                                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "S\u00E9lection Vue")),
                                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 9 },
                                            react_1.default.createElement(react_bootstrap_1.Form.Select, { id: "selectionNode", onChange: (evt) => {
                                                    if (evt.target.value === '') {
                                                        return;
                                                    }
                                                    multi_selected_nodes.current = [];
                                                    multi_selected_links.current = [];
                                                    multi_selected_label.current = [];
                                                    set_view(evt.target.value);
                                                } },
                                                react_1.default.createElement("option", { selected: view == 'none', value: 'none' }, "Donn\u00E9es actuelles"),
                                                data.view.map(d => {
                                                    return react_1.default.createElement("option", { key: d.id, selected: view == d.id, value: d.id }, d.nom);
                                                })))),
                                    react_1.default.createElement(react_bootstrap_1.Table, { bordered: true, size: 'sm' },
                                        react_1.default.createElement("thead", null,
                                            react_1.default.createElement("tr", null,
                                                react_1.default.createElement("th", null, "Nom"),
                                                react_1.default.createElement("th", null, "Position"),
                                                react_1.default.createElement("th", null))),
                                        react_1.default.createElement("tbody", null, Object.values(data.view).map(d => {
                                            return (react_1.default.createElement("tr", { style: { 'border': (d.id == view) ? '2px solid red' : 'none' } },
                                                react_1.default.createElement("td", null,
                                                    react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', value: d.nom, onChange: evt => {
                                                            data.view.filter(v => v.id == d.id)[0].nom = evt.target.value;
                                                            set_data(Object.assign({}, data));
                                                        } })),
                                                react_1.default.createElement("td", null,
                                                    react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "button_position", size: "sm" },
                                                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "success", onClick: () => {
                                                                let ind = -1;
                                                                data.view.map((v, i) => {
                                                                    ind = (v.id == d.id) ? i : ind;
                                                                });
                                                                const toShift = data.view[ind];
                                                                data.view.splice(ind, 1);
                                                                data.view.splice(ind - 1, 0, toShift);
                                                                set_data(Object.assign({}, data));
                                                            } },
                                                            react_1.default.createElement(fa_1.FaArrowUp, null)),
                                                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "success", onClick: () => {
                                                                let ind = -1;
                                                                data.view.map((v, i) => {
                                                                    ind = (v.id == d.id) ? i : ind;
                                                                });
                                                                const toShift = data.view[ind];
                                                                data.view.splice(ind, 1);
                                                                data.view.splice(ind + 1, 0, toShift);
                                                                set_data(Object.assign({}, data));
                                                            } },
                                                            react_1.default.createElement(fa_1.FaArrowDown, null)))),
                                                react_1.default.createElement("td", null,
                                                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', onClick: () => {
                                                            let ind = -1;
                                                            data.view.map((v, i) => {
                                                                ind = (v.id == d.id) ? i : ind;
                                                            });
                                                            data.view.splice(ind, 1);
                                                            set_view('none');
                                                            set_data(Object.assign({}, data));
                                                        } },
                                                        react_1.default.createElement(fa_1.FaMinus, null)))));
                                        })))),
                                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux", title: "Filtres Flux" },
                                    react_1.default.createElement(react_bootstrap_1.Form, null,
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Mode structure', checked: data.show_structure, onChange: evt => {
                                                        data.show_structure = evt.target.checked;
                                                        set_data(Object.assign({}, data));
                                                    } }))),
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Filtre")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: filter, onChange: evt => set_current_filter(Number(evt.target.value)) })),
                                            react_1.default.createElement(react_bootstrap_1.Col, null, filter)),
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Filtre label")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: data.display_style.filter_label, onChange: evt => {
                                                        data.display_style.filter_label = +evt.target.value;
                                                        set_data(Object.assign({}, data));
                                                    } })),
                                            react_1.default.createElement(react_bootstrap_1.Col, null, data.display_style.filter_label)),
                                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Flux nuls:")),
                                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Visible', onChange: evt => {
                                                        data.display_style.null_flux = evt.target.checked;
                                                        set_data(Object.assign({}, data));
                                                    } })))))))),
                    react_1.default.createElement(Accordion_1.default.Item, { style: { 'display': (view == 'none' && data.accordeonToShow.includes('Leg')) ? 'block' : 'none' }, eventKey: "legend", onClick: evt => {
                            if (evt.target.className === 'accordion-button' && nav_item_active === 'legend') {
                                set_nav_item_active('');
                            }
                            else {
                                set_nav_item_active('legend');
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, null, "L\u00E9gendes"),
                        react_1.default.createElement(Accordion_1.default.Body, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "L\u00E9gende X")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: legend_position[0], onChange: evt => set_legend_position([+evt.target.value, legend_position[1]]), onBlur: () => {
                                            data.legend_position = legend_position;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "L\u00E9gende Y")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: legend_position[1], onChange: evt => set_legend_position([legend_position[0], +evt.target.value]), onBlur: () => {
                                            data.legend_position = legend_position;
                                            set_data(Object.assign({}, data));
                                        } }))),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Largeur L\u00E9gende")),
                                react_1.default.createElement(react_bootstrap_1.Col, null,
                                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "number", step: 1, value: data.legend_width, onChange: evt => {
                                            data.legend_width = +evt.target.value;
                                            set_data(Object.assign({}, data));
                                        } }))))))))
            : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_bootstrap_1.Toast, { bg: 'success', className: 'toastView', show: show_toast, style: { 'position': 'absolute', 'marginTop': '300px', 'marginLeft': '250px', 'zIndex': 1 } },
            react_1.default.createElement(react_bootstrap_1.Toast.Header, { closeButton: false },
                react_1.default.createElement(fa_1.FaSave, null),
                " ",
                react_1.default.createElement("small", { className: 'me-auto' }, "Enregistrement"),
                " "),
            react_1.default.createElement(react_bootstrap_1.Toast.Body, null, "Vue sauvegard\u00E9e")),
        processing ? (react_1.default.createElement(react_bootstrap_1.Modal.Dialog, null,
            react_1.default.createElement(react_bootstrap_1.Button, { className: "btn btn-sm btn-warning col-md-12" },
                react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                " Processing..."))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        (view != 'none') ? (react_1.default.createElement(SankeyDraw_1.default, { data: viewOfData(), set_data: () => null, 
            //set_multi_selected_nodes={() => null}
            multi_selected_nodes: multi_selected_nodes, 
            //set_multi_selected_links={() => null}
            multi_selected_links: multi_selected_links, 
            //set_multi_selected_label={set_multi_selected_label}
            multi_selected_label: multi_selected_label, select_node: () => null, node_arrow_visible: (n) => !n.node_visible || (n.inputLinksId.length === 0) || (!viewOfData().links[n.inputLinksId[0]].arrow) ? false : true, select_link: () => null, link_text: SankeyUtils_1.link_text, test_link_value: SankeyUtils_1.test_link_value, 
            // set_show_nav={set_show_nav}
            // set_nav_item_active={set_nav_item_active}
            // set_sub_nav_item_active={set_sub_nav_item_active}
            nodeTooltipsContent: SankeyTooltip_1.nodeTooltipsContent, linkTooltipsContent: SankeyTooltip_1.linkTooltipsContent, set_show_toast: set_show_toast, current: false, mode_selection: mode_selection, set_mode_selection: set_mode_selection, view: view, set_view: set_view, mode_visualisation: mode_visualisation })) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(ApplyLayoutDialog, { show_apply_layout: show_apply_layout, set_show_apply_layout: set_show_apply_layout, sankey_data: data, set_sankey_data: set_data }),
        show_excel_dialog ? (react_1.default.createElement(ExcelModal, { handleCloseDialog: () => set_show_excel_dialog(false), uploadExcelImpl: exports.uploadExcelImpl, set_data: set_data, data: data, set_show_excel_dialog: set_show_excel_dialog })) :
            (react_1.default.createElement("div", null)),
        show_publish_dialog ? (react_1.default.createElement(PublishModal, { set_show_publish_dialog: set_show_publish_dialog, publishImpl: publishImpl, file_path_initial: data.file_name })) :
            (react_1.default.createElement("div", null))));
};
const ApplyLayoutDialogPropTypes = {
    show_apply_layout: prop_types_1.default.bool.isRequired,
    set_show_apply_layout: prop_types_1.default.func.isRequired,
    sankey_data: types_1.SankeyDataPropTypes,
    set_sankey_data: prop_types_1.default.func.isRequired
};
const ApplyLayoutDialog = ({ show_apply_layout, set_show_apply_layout, sankey_data, set_sankey_data }) => {
    let file_layout;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_apply_layout, onHide: () => set_show_apply_layout(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Appliquer mise en page")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Fichier de mise en page")),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => file_layout = evt.target.files })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                                if (file_layout === undefined) {
                                    return;
                                }
                                const reader = new FileReader();
                                reader.onload = (() => {
                                    return ((e) => {
                                        let result = e.target.result;
                                        if (result) {
                                            result = String(result).split('<br>').join('\\\\n');
                                            const new_layout = JSON.parse(result);
                                            (0, SankeyLayout_1.updateLayout)(sankey_data, new_layout);
                                            set_sankey_data(Object.assign({}, sankey_data));
                                        }
                                    });
                                })();
                                reader.readAsText(file_layout[0]);
                            } }, "Appliquer Disposition")))))));
};
const ExcelModalPropTypes = {
    uploadExcelImpl: prop_types_1.default.func.isRequired,
    handleCloseDialog: prop_types_1.default.func.isRequired,
    set_data: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_show_excel_dialog: prop_types_1.default.func.isRequired
};
const ExcelModal = ({ uploadExcelImpl, handleCloseDialog, set_data, data, set_show_excel_dialog }) => {
    const [input_file_name, set_input_file_name] = (0, react_1.useState)(undefined);
    const [layout_file, set_layout_file] = (0, react_1.useState)(undefined);
    const [sheet] = (0, react_1.useState)('results');
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: handleCloseDialog },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Ouvrir Fichier Excel")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Fichier d'entr\u00E9e excel"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => {
                            set_input_file_name(evt.target.files[0]);
                        } })),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Layout"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", 
                        //ref={layout_file_}
                        name: "", onChange: (evt) => {
                            set_layout_file(evt.target.files[0]);
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => uploadExcelImpl(data, set_data, set_show_excel_dialog, input_file_name, sheet, (sankey_data) => {
                    if (layout_file === undefined) {
                        return;
                    }
                    const reader = new FileReader();
                    reader.onload = (() => {
                        return ((e) => {
                            let result = e.target.result;
                            if (result) {
                                result = String(result).split('<br>').join('\\\\n');
                                const data = JSON.parse(result);
                                (0, SankeyLayout_1.updateLayout)(sankey_data, data);
                                set_data(Object.assign({}, sankey_data));
                                // if (data.agregation.level === -1) {
                                //   localStorage.setItem('initial_data', LZString.compress(JSON.stringify(sankey_data)))
                                // }
                            }
                        });
                    })();
                    reader.readAsText(layout_file);
                }) }, "Ouvrir"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: handleCloseDialog }, "Annuler"))));
};
ExcelModal.propTypes = ExcelModalPropTypes;
const PublishModalPropTypes = {
    publishImpl: prop_types_1.default.func.isRequired,
    set_show_publish_dialog: prop_types_1.default.func.isRequired,
    file_path_initial: prop_types_1.default.string.isRequired
};
const PublishModal = ({ publishImpl, set_show_publish_dialog, file_path_initial }) => {
    const [file_path, set_file_path] = (0, react_1.useState)(file_path_initial);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => set_show_publish_dialog(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Publication/Mise \u00E0 jour du diagramme")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Chemin d'acc\u00E9s"),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', placeholder: file_path_initial, onChange: (evt) => set_file_path(evt.target.value) }))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => publishImpl(file_path) }, "Publier"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => set_show_publish_dialog(false) }, "Annuler"))));
};
PublishModal.propTypes = PublishModalPropTypes;
Menu.propTypes = MenuPropTypes;
exports.default = Menu;
